// Utilitário centralizado para saber se existe componente implementado para um documentId
// Use este utilitário tanto no AuthRoutes quanto no RouteValidator e ThirdLevelLayout

export const implementedComponentMap: Record<string, boolean> = {
  'marketplace-advisor': true,
  'marketplace-courses': true,
  'marketplace-services': true,
  'marketplace-plans': true,
  bhnrs7gefue5v5ntzqg3ls74: true, // Cockpit
  eh04q5jlhm52tnh1tthycrkd: true, // CockpitAgenda
  c7jp5768k53sra3u6bv5ynxg: true, // IndividualBio
  orggc8xfsjhi06uojgmcnifc: true, // CollectiveProfileMembers
  md1wm0c8mnn6t8j0k62aywmy: true, // EducationShowcase
  blm0udkzzi2tixjhb6knp3h4: true, // EducationMyCourses
  bf2t3hejquw6g50ok47yujs8: true, // EducationFavorites
  x8vn7552j2z8motvcpzq2dp5: true, // AtivacaoPresencial
  xxo09iaggq9nwdz1k6384su7: true, // PBIDash
  ij94qlo086g27564ecpwuodc: true, // PBIDash
  qk2dzqrdfefnut2qtisy2zbl: true, // PBIDash
  ld9rsfvvtjxk1awhj65vrmit: true, // PBIDash
  wkfn4hkgdw13y86o9yxu41pq: true, // PBIDash
  ah06bmqiaqi7oxigam2836u1: true, // BasicPersonalData
  yuheaauamsvg289gn5ac2ogk: true, // CompanyData
  nwdjh4f3wj95xej5a30iri2q: true, // InvitesPage
  wfrhqdqgq51gqj4kcswgvg0r: true, // GovernanceThematicGroups
  b0i2qi0dhqmelqonbhn3pzn5: true, // GovernanceUsers
  bv5n1nkso2vewyx5gilyblgu: true, // GovernanceEvents
  qec5xuvx1dq05uuczz52irrq: true, // OrchestratorEducationCategories
  nhaa2ypwl4zbsfu8xkaf0k17: true, // Courses
  opp497btmueyywpgzbr7e835: true, // Lessons
  tegujpnuqitwwjxdw3mqhf00: true, // UnderConstruction
  meeting_room: true, // Meeting room
  rp6pr14xcoibtn5p9qd0ip8z: true, // AdvisorsMarketplace
  f0pzvvpx9kvxz2ejkubibdys: true, // GeneralMarketplace
  hqqnrfpu1ox2iqdzoa81pmt3: true, // GeneralMarketplace
  g58dvhpca9eirq6gln0f2fyi: true, // ServicesMarketplace
  nql7so3er7p473mkgzawkla7: true, // GeneralMarketplace
  s56a1gugf03ngwgsp4zr3nho: true, // AgendaConfiguration
  vpquicugxm4w5svpjji0b3ox: true, // AccessHub
  ttuofh4gmf7xs8vv8ee6xi6s: true, // AdvisorsAccessHub
  k2acxd0qf2eiwtevt4xn5oa1: true, // LeadRequestOrchestration
  lk0yriz57vt600loevyonvq2: true,
  jxm4lel4ot7ihnap5xwkmtyf: true,
};

export function hasImplementedComponent(documentId: string): boolean {
  return !!implementedComponentMap[documentId];
}
